import React, { useState } from 'react';
import Octapharma from '../../assets/Octapharma.svg';
import Galenika from '../../assets/galenika.svg';
import Hubner from '../../assets/hubner.svg';
import dr_pfleger from '../../assets/dr_pfleger.svg';
import alfa_intes from '../../assets/alfa_intes.svg';
import './partners.css';
import { useTranslation } from 'react-i18next';

function Partners() {
  const { t } = useTranslation('global');
  const [openKey, setOpenKey] = useState(null);

  const partners = [
    {
      key: 'octapharma',
      logo: Octapharma,
      nameKey: 'our_partners.octapharma',
      textKey: 'our_partners.text_octa',
      buttonKey: 'our_partners.button_octa',
      href: 'https://www.octapharma.com/serbia/',
    },
    {
      key: 'galenica',
      logo: Galenika,
      nameKey: 'our_partners.galenica',
      textKey: 'our_partners.text_galenica',
      buttonKey: 'our_partners.button_galenica',
      href: 'https://galenica.gr/en/',
    },
    {
      key: 'dr_pfleger',
      logo: dr_pfleger,
      nameKey: 'our_partners.dr_pfleger',
      textKey: 'our_partners.text_dr_pfleger',
      buttonKey: 'our_partners.button_dr_pfleger',
      href: 'https://dr-pfleger.de/',
    },
    {
      key: 'alfa_intes',
      logo: alfa_intes,
      nameKey: 'our_partners.alfa_intes',
      textKey: 'our_partners.text_alfa_intes',
      buttonKey: 'our_partners.button_alfa_intes',
      href: 'https://www.alfaintes.it/en',
    },
    {
      key: 'hubner',
      logo: Hubner,
      nameKey: 'our_partners.hubner',
      textKey: 'our_partners.text_hubner',
      buttonKey: 'our_partners.button_hubner',
      href: 'https://huebner-vital.com/en/',
    },
  ];

  const toggle = (key) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  return (
    <section className="partners" id="our_partners" aria-labelledby="partners-title">
      <div className="bm-container">
        <header className="partners__header">
          <h1 id="partners-title">{t('our_partners.title')}</h1>
        </header>

        <div className="partners__grid">
          {partners.map((partner, index) => {
            const isOpen = openKey === partner.key;
            return (
              <article
                key={partner.key}
                className={`partner-card${isOpen ? ' is-open' : ''}`}
              >
                <div className="partner-card__meta">
                  <span className="partner-card__index">0{index + 1}</span>
                  <div className="partner-card__logo">
                    <img src={partner.logo} alt={t(partner.nameKey)} loading="lazy" />
                  </div>
                </div>
                <h3>{t(partner.nameKey)}</h3>
                <p className="partner-card__text">
                  <span className="partner-card__name">{t(partner.nameKey)}</span>
                  {t(partner.textKey)}
                </p>
                <div className="partner-card__actions">
                  <button
                    type="button"
                    className="partner-card__toggle"
                    onClick={() => toggle(partner.key)}
                    aria-expanded={isOpen}
                  >
                    {isOpen
                      ? t('our_partners.show_less')
                      : t('our_partners.show_more')}
                    <span aria-hidden="true">{isOpen ? '−' : '+'}</span>
                  </button>
                  <a
                    className="partner-card__link"
                    href={partner.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t(partner.buttonKey)} →
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Partners;
